var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7864 0.580077C12.3993 0.705359 12.2993 0.781577 11.5676 1.50864L10.8645 2.20736L12.5753 3.91876L14.2861 5.63014L14.946 4.97404C15.6503 4.27379 15.8125 4.06729 15.9138 3.74208C16.0556 3.28711 16.0231 2.8682 15.8119 2.42733C15.6916 2.17626 15.6476 2.1247 15.0089 1.4867C14.2885 0.767015 14.1652 0.676702 13.7537 0.567171C13.5129 0.503109 13.0032 0.50989 12.7864 0.580077ZM5.45163 7.62267L1.00763 12.0679L0.500882 14.0992C0.129257 15.5887 0.000100447 16.1541 0.0165067 16.2191C0.0446005 16.3302 0.16185 16.4497 0.269288 16.4766C0.355569 16.4983 4.25901 15.5516 4.41138 15.4721C4.45435 15.4497 6.47585 13.4441 8.9036 11.0152L13.3177 6.59904L11.6067 4.88823L9.8956 3.17739L5.45163 7.62267Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a57ee842fc58d5b6e4674284db86f3ee.svg";
export { ForwardRef as ReactComponent };